import { render, staticRenderFns } from "./QuizReportCardView.vue?vue&type=template&id=1744db20&scoped=true"
import script from "./QuizReportCardView.vue?vue&type=script&lang=js"
export * from "./QuizReportCardView.vue?vue&type=script&lang=js"
import style0 from "./QuizReportCardView.vue?vue&type=style&index=0&id=1744db20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1744db20",
  null
  
)

export default component.exports